
    import { Options, Vue } from 'vue-class-component';

    @Options({
        props: {
            title: String,
            padding: String,
            headerTabs: Boolean,
        },
    })
    export default class BasicPage extends Vue {
        protected padding!: number;

        get hasHeaderTabsSlot() {
            return !!this.$slots['header-tabs'];
        }
    }
